// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_landing1 = /** @type {(inputs: {}) => string} */ () => {
	return `walk`
};

const el_landing1 = /** @type {(inputs: {}) => string} */ () => {
	return `περπάτα`
};

const ru_landing1 = /** @type {(inputs: {}) => string} */ () => {
	return `ходи`
};

const he_landing1 = /** @type {(inputs: {}) => string} */ () => {
	return `צעד`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const landing1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing1", locale)
	if (locale === "en") return en_landing1(inputs)
	if (locale === "el") return el_landing1(inputs)
	if (locale === "ru") return ru_landing1(inputs)
	if (locale === "he") return he_landing1(inputs)
	return "landing1"
};